/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BehaviorGraphType } from '../../models/behavior-graph-type';
import { GraphDataModel } from '../../models/graph-data-model';
import { GraphGrouping } from '../../models/graph-grouping';

export interface GetBehaviorGraph$Params {
  patientID?: number;
  behaviorID?: number;
  startTime?: string;
  endTime?: string;
  graphType?: BehaviorGraphType;
  graphGrouping?: GraphGrouping;
  staffID?: number;
  includeTrendLine?: boolean;
  showNotTrackedAsZeroes?: boolean;
}

export function GetBehaviorGraph(http: HttpClient, rootUrl: string, params?: GetBehaviorGraph$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphDataModel>> {
  const rb = new RequestBuilder(rootUrl, GetBehaviorGraph.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('behaviorID', params.behaviorID, {});
    rb.query('startTime', params.startTime, {});
    rb.query('endTime', params.endTime, {});
    rb.query('graphType', params.graphType, {});
    rb.query('graphGrouping', params.graphGrouping, {});
    rb.query('staffID', params.staffID, {});
    rb.query('includeTrendLine', params.includeTrendLine, {});
    rb.query('showNotTrackedAsZeroes', params.showNotTrackedAsZeroes, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GraphDataModel>;
    })
  );
}

GetBehaviorGraph.PATH = '/api/Graph/GetBehaviorGraph';
